import { theme } from '@app/theme';

// Palette des états de caisse (chantier 9c-B). `fiscal.logic.ts` reste pure et
// ignore le thème : elle nomme la couleur (`vert`, `gris`, …), cette table la
// traduit. Partagée par la liste et la fiche pour qu'elles ne divergent pas.
// Le vert et l'orange n'existent pas dans `theme.colors` : ils sont littéraux.
export const COULEUR_ETAT = {
  vert: '#2AA831',
  gris: theme.colors.grey,
  orange: '#FF8C00',
  rouge: theme.colors.crimson,
} as const;
